<template>
  <div class="home" style="min-width:1440px;">
    
    <!-- 轮播 -->
    <div ref="element" >
      <el-carousel class="banner" >
        <el-carousel-item v-for="item in banners" :key="item.id" >
          <!-- <router-link :to="item.url"> -->
            <img :src="item.url"  width=100% height=100%/>
          <!-- </router-link> -->
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <div>{{$t("message.title")}}</div> -->
    <!-- <div class="left" style="position:absolute;top:10px;z-index:100;width:100%">
      <div style="margin-left:100px">
        <img src="../assets/img/tou.png" alt />
      </div>
      <div class="centers"  style="flex:1;color:#FFFFFF">
        <div>首页</div>
        <div>关于联盟</div>
        <div>成员单位</div>
        <div>展览交流</div>
        <div>论坛文章</div>
        <div>作品展示</div>
        <div>会员邀请</div>
        <div>诚邀赞助</div>
        <div>联系我们</div>
      </div>
      <div style="margin-right:104px">{{ce}}</div>
    </div> -->
    <!-- 联盟介绍 -->
    <div class="union_info animated fadeInUp centersTop" style="min-width:1440px;padding-right:5%;height:">
      <div ref="zhengjain" style="width:60%;margin-right:5%;margin-top:6%;padding-bottom:15%">
        <div ref="zhengjains"  style="margin-left:62%;box-shadow:14px 20px 16px  #F5F5F5">
        <!-- <div style="margin-left:62%;width:383px;heiht:446px"> -->
          <img :src="urlsecond" alt width=100% />
        </div>
      </div>
      <div style="flex:1;" ref="turan">
        <div class="centersTop" ref="elements">
          <div style="margin-top:8%" ref="elementsd">
            <!-- <div v-if="chOrEn!='0'" style="min-width:240px;font-size:40px;font-weight: bold;line-height: 56px;">雕塑园(馆)国际联盟介绍</div> -->
            <div v-if="chOrEn!='0'" style="min-width:270px;font-size:40px;font-weight: bold;line-height: 56px;">雕塑园(馆)</br>国际联盟介绍</div>
            <div v-else  style="min-width:240px;font-size:40px;font-weight: bold;line-height: 56px;">Introduction to ISPU</div>
            <!-- <div v-if="chOrEn!='0'" style="margin-top:10px;color: #C0CCDA;font-size: 20px;font-weight: bold;line-height: 24px;">ALLIANCE IS INTRODUCED</div> -->
            <!-- <div v-if="chOrEn!='0'" style="margin-top:10px;color: #C0CCDA;font-size: 20px;font-weight: bold;line-height: 24px;">Introduction to ISPU</div>
            <div v-else  style="margin-top:10px;color: #C0CCDA;font-size: 20px;font-weight: bold;line-height: 24px;">联盟介绍</div> -->
          </div>

          <div style="width:50%;" >
            <img src="../assets/img/logoshree.png" width=100%  />
          </div>
        </div>
        
        <!-- <div id="div" style="width:100%;height:100%;overflow-y: scroll;">
          <div>
            <p v-html="summary" style="padding-right:35%">{{summary}}</p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="centers" ref="gaos" style="position: absolute;width:100%;z-index:2" :style="{top: gao}">
          <img src="../assets/img/beione.png" alt width=100%  />
    </div>
    <div class="union_info animated fadeInUp centersTop" style="z-index:4;padding-right:5%;position: absolute;top: 677px;min-width:1440px;" >
      <div style="width:60%;margin-right:5%;margin-top:10%">
        <div style="height:500px;margin-left:62%;">
          <img :src="urlsecond" alt width=100% v-show=false />
        </div>
      </div>
      <div style="flex:1;margin-top:30px;" > 
        <div class="centersTop" v-show=false>
          <div>
            <div style="font-size:40px;font-weight: bold;line-height: 56px;">雕塑公园(馆)国际联盟介绍</div>
            <div style="margin-top:10px;color: #C0CCDA;font-size: 20px;font-weight: bold;line-height: 24px;">ALLIANCE IS INTRODUCED</div>
          </div>
          <div style="width:50%;" >
            <img src="../assets/img/logoshree.png" width=100%  />
          </div>
        </div>
        <div v-if="ggg" id="div" class="reds"  style="margin-top:0px;height:350px;padding-bottom:30px" :style="{height: sdf}">
          <!--<h2>雕塑园（馆）国际联盟秘书处位于长春世界雕塑园</h2>-->
          <!-- <p>长春世界雕塑园位于长春市核心区，占地面积92公顷，其中水域面积11.8公顷，是集自然山水与人文景观于一体现代城市雕塑主题景区，国家AAAAA级景区, 首批“国家重点公园”,首批“创造未来文化遗产”示范单位，并获得了“新中国城市雕塑建设成就奖”中唯一一个"雕塑公园成就奖"。</p>
          <p> 景区始建于2000年，2003年9月5日正式对外开放。通过长春国际雕塑作品邀请展等大型活动，园内汇集了来自五大洲216个国家和地区的10021件（组）雕塑、绘画等艺术作品</p> -->
          <div :style="{height: sdf}">
            <!-- <p v-html="mechanism.content" style="font-size:18px">{{mechanism.content}}</p> -->
            <div v-html="summary"   style="text-overflow: ellipsis;text-align:left;margin-top:10px;color:#2A303C;font-size:16px;line-height: 32px;padding-right:38%">{{summary}}</div>
          </div>
          <!-- <router-link  v-if="chOrEn!='0'" to='/union'>了解更多</router-link>
          <router-link v-else to='/union'>understand more</router-link> -->
        </div>
        <div v-if="!ggg"  id="div" class="reds"  style="margin-top:0px;height:320px" >
          <!--<h2>雕塑园（馆）国际联盟秘书处位于长春世界雕塑园</h2>-->
          <!-- <p>长春世界雕塑园位于长春市核心区，占地面积92公顷，其中水域面积11.8公顷，是集自然山水与人文景观于一体现代城市雕塑主题景区，国家AAAAA级景区, 首批“国家重点公园”,首批“创造未来文化遗产”示范单位，并获得了“新中国城市雕塑建设成就奖”中唯一一个"雕塑公园成就奖"。</p>
          <p> 景区始建于2000年，2003年9月5日正式对外开放。通过长春国际雕塑作品邀请展等大型活动，园内汇集了来自五大洲216个国家和地区的10021件（组）雕塑、绘画等艺术作品</p> -->
          <div :style="{height: sdf}">
            <!-- <p v-html="mechanism.content" style="font-size:18px">{{mechanism.content}}</p> -->
            <div v-html="summary"   style="text-align:left;margin-top:10px;color:#2A303C;font-size:16px;line-height: 32px;padding-right:38%">{{summary}}</div>
          </div>
          <!-- <router-link  v-if="chOrEn!='0'" to='/union'>了解更多</router-link>
          <router-link v-else to='/union'>understand more</router-link> -->
        </div>
        <div style="margin-top:30px">
              <div style="width:284px;background: #24367D;color: #fff;font-size: 18px;text-align: center;line-height: 40px;height: 40px;cursor: pointer;" v-if="chOrEn!='0'" @click="goUnion">了解更多<span style="margin-left:10px" class="el-icon-right"></span></div>
              <div style="width:284px;background: #24367D;color: #fff;font-size: 18px;text-align: center;line-height: 40px;height: 40px;cursor: pointer;" v-else @click="goUnion">more<span style="margin-left:10px" class="el-icon-right"></span></div>
            </div>
          <!-- <div style="margin-top:10px">
            <div style="width: 128px;background: #24367D;color: #fff;font-size: 18px;text-align: center;line-height: 40px;height: 40px;border-radius: 5px;cursor: pointer;" v-if="chOrEn!='0'" @click="goUnion">了解更多<span style="margin-left:10px" class="el-icon-right"></span></div>
            <div style="width: 128px;background: #24367D;color: #fff;font-size: 18px;text-align: center;line-height: 40px;height: 40px;border-radius: 5px;cursor: pointer;" v-else @click="goUnion">more<span style="margin-left:10px" class="el-icon-right"></span></div>
          </div> -->
        <!-- <div id="div" style="width:100%;height:100%;overflow-y: scroll;">
          <div>
            <p v-html="summary" style="padding-right:35%">{{summary}}</p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="union_info animated fadeInUp centers">
<!-- 123 -->
    </div>
    <!-- 联盟倡议 -->
    <div  ></div>
    <div class="union_initiatives" ref="piediv" :style='y_bj' >
      <div class="union_initiatives_mask" >
        <div class="container" style="padding:0px 0px 0px 0px;width:100%">
          <!-- <div id="div" class="reds"  >
            <div >
              <p v-html="summary" style="padding-right:35%">{{summary}}</p>
            </div>
          </div> -->
          <div class="initiatives_left animated slideInLeft " ref="de" style="height:100%;z-index:-1px;width:50%;background:#17263C">
            <!-- <div style="margin-right:10%;margin-left:46%;margin-top:10%"> -->
            <div class="beijingtupian" style="height:100%;background-position-y: 180px;" :style="{'background-position-x': xinjia  }">
              <div class="flexEnd">
                <div style="margin-top:116px;"></div>
                <div  style="margin-right:10%;margin-top:10%;width:440px">
                  <h1  style="font-size:32px;color:#FFDDAB;text-align:left;height:66px"><img src="../assets/img/wang.png"  height=66px  /></h1>
                </div>
              </div>
              <div class="flexEnd">
                <div  style="margin-right:10%;margin-top:2px;width:440px">
                  <h1  style="font-size:32px;color:#FFDDAB;text-align:left">{{baseByNavtit.title}}</h1>
                </div>
              </div>
              <div class="flexEnd " style="margin-top:20px;flex:1;height:224px">
                <div id="div" class="reds" style="margin-right:10%">
                  <div style="width:440px;">
                    <div>
                      <div ref="dsaf" v-html="baseByNavtit.summary" style="line-height: 32px;font-size:16px;text-align:left;text-overflow: ellipsis;color:#E1E7E6">{{baseByNavtit.summary}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flexEnd">
                <div class="flexStart" style="width:440px;margin-right:10%;margin-top:32px">
                  <div class="check_mores" style="margin-top:30px;margin-bottom:10%" v-if="chOrEn!='0'" @click="goProposal">了解更多<span style="margin-left:10px" class="el-icon-right"></span></div>
                  <div class="check_mores" style="margin-top:30px;margin-bottom:10%" v-else @click="goProposal">more <span style="margin-left:10px" class="el-icon-right"></span></div>
                </div>
              </div>
            </div>
            <!-- <p>发送{{baseByNavtit.content}}</p> -->
          </div>
          <div class="initiatives_right animated slideInRight" style="flex:1;" :style="{'margin-top': nate+'px'}" >
            <video-player
              class="video-player vjs-custom-skin tuji"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
              style="width= 100%; height=100%; "
            ></video-player>
          </div>
        </div>
      </div>
    </div>
    <!-- 董事会机构 -->
    <!-- <div class="board_directors">
      <div class="container">
        <home-item-title title="董事会机构" des="联盟董事会成员由5名人员组成"></home-item-title>
        <home-director-list :list="directors"></home-director-list>
      </div>
    </div> -->
    
    
    <!-- 成员单位 -->
    <div style="height:100%;background:#FAFAFC;padding-bottom:70px;min-width:1440px;" >
      <div class="member"  >
        <div class="container" style="min-width:1200px">
          <home-item-title v-if="chOrEn!='0'" style="text-align:left;margin-left:5%" title="雕塑园(馆)国际联盟成员单位" ></home-item-title>
          <home-item-title v-else style="text-align:left;margin-left:5%" title="International Sculpture Park(Gallery/Museum) Union Member" ></home-item-title>
          <div class="left">
            <div class="el-icon-back cent" @click="zuo" style=";cursor: pointer;background:#17263C;width:40px;height:160px;color:#FAFAFC"></div>
            <div ref="divIts" style="width:100%;overflow-x:scroll;padding-bottom:5px" id="divIt">
              <div :style="'width:'+num" ref="zhis" style="opacity:1;">
                <home-member-list :list='memberunitList' ref="zhi">
                </home-member-list>
              </div>
            </div>
            <div class="el-icon-right cent" @click="you" style=";cursor: pointer;background:#17263C;width:40px;height:160px;color:#FAFAFC"></div>
          </div>
          <div id="allmap" ></div>
          <!-- <div class="check_more" v-if="chOrEn!='0'" @click="goMemeber">了解更多</div> -->
          <!-- <div class="check_more" v-else @click="goMemeber">more</div> -->
        </div>
      </div>
    </div>
    <!-- 秘书处机构 -->
    <div class="secretariat">
      <div class="container" style="min-width:1200px">
        <!-- <home-item-title :title="mechanism.title" ></home-item-title> -->
        <div class="secretariat_content"  >
          <div class="content_left" style="z-index:2" ref="zhuanZi">
            <img :src="mechanism.urlfirst" alt="">
          </div>
          <div class="zhuan" style="z-index:2" :style="{'left':wei+'px','top':weiTop+'px'}">
            UNION SECRETARIAT
            <!-- <img src="../assets/img/juxing.png" width=100%  /> -->
          </div>
          <div class="zhuans" ref="imgs"  :style="{'left':weis+'px','top':weiTops+'px'}">
            <!-- Alliance Secretariat -->
            <img src="../assets/img/juxing.png" width=100%  />
          </div>
          <div id="div" class="content_right " style="margin-left:10%;line-height: 36px; font-size: 18px;font-weight:400;color: #575757;">
            <!--<h2>雕塑园（馆）国际联盟秘书处位于长春世界雕塑园</h2>-->
            <!-- <p>长春世界雕塑园位于长春市核心区，占地面积92公顷，其中水域面积11.8公顷，是集自然山水与人文景观于一体现代城市雕塑主题景区，国家AAAAA级景区, 首批“国家重点公园”,首批“创造未来文化遗产”示范单位，并获得了“新中国城市雕塑建设成就奖”中唯一一个"雕塑公园成就奖"。</p>
            <p> 景区始建于2000年，2003年9月5日正式对外开放。通过长春国际雕塑作品邀请展等大型活动，园内汇集了来自五大洲216个国家和地区的10021件（组）雕塑、绘画等艺术作品</p> -->
            <div>
              <div v-if="chOrEn!='0'" class="flexStart" style="color:#2A303C;font-size:40px;font-weight:bold;">
                <!-- <div style="width:206px">
                  <img src="../assets/img/weizhi.png" width=100%  />
                </div> -->
                <div style="">
                  雕塑园(馆)国际联盟秘书处
                </div>
              </div>
              <div v-else class="flexStart" style="color:#2A303C;font-size:40px;font-weight:bold;">
                <!-- <div style="width:206px">
                  <img src="../assets/img/weizhi.png" width=100%  />
                </div> -->
                <div style="line-height: 56px;">
                  International Sculpture Park(Gallery/Museum) Union Secretariat
                </div>
              </div>
              <div v-if="chOrEn!='0'" :style="{'height':mi-90+'px'}" style="margin-top:35px">
                <div id="div" class="reds" >
                  <div>
                    <div >
                      <!-- <p v-html="mechanism.content" style="font-size:18px">{{mechanism.content}}</p> -->
                      <div v-html="mechanism.summary" style="line-height: 32px;text-overflow: ellipsis;font-size:16px;text-align:left;white-space: pre-wrap;">{{mechanism.summary}}</div>
                    </div>

                  </div>

                </div>
              </div>

              <div v-if="chOrEn =='0'" :style="{'height':mi-190+'px'}" style="margin-top:35px">
                <div id="div" class="reds" >
                  <div>
                    <div >
                      <!-- <p v-html="mechanism.content" style="font-size:18px">{{mechanism.content}}</p> -->
                      <div v-html="mechanism.summary" style="line-height: 32px;text-overflow: ellipsis;font-size:16px;text-align:left;white-space: pre-wrap;">{{mechanism.summary}}</div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
            <!-- <div id="div" class="reds" style="height:40%">
              <div style="margin-right:10%;margin-left:46%;">
                <div>
                  <p style="font-size:16px">{{baseByNavtit.summary}}</p>
                </div>
              </div>
            </div> -->
            <div style="margin-top:30px">
              <div style="width: 284px;background: #24367D;color: #fff;font-size: 18px;text-align: center;line-height: 40px;height: 40px;cursor: pointer;" v-if="chOrEn!='0'" @click="goMemeber">了解更多<span style="margin-left:10px" class="el-icon-right"></span></div>
              <div style="width: 284px;background: #24367D;color: #fff;font-size: 18px;text-align: center;line-height: 40px;height: 40px;cursor: pointer;" v-else @click="goMemeber">more<span style="margin-left:10px" class="el-icon-right"></span></div>
            </div>
            <!-- <router-link  v-if="chOrEn!='0'" to='/union'>了解更多</router-link>
            <router-link v-else to='/union'>understand more</router-link> -->
          </div>
        </div>
      </div>
    </div>
    <div class="member">
    <!-- <div id="allmap" ></div> -->
      <div id="all" ></div>
    </div>
    <Contacts></Contacts>
  </div>
</template>

<script>
import {BmlHeatmap} from '../../custom_map_config'
// @ is an alias to /src
import HomeItemTitle from "@/components/HomeItemTitle.vue";
import HomeDirectorList from "@/components/HomeDirectorList.vue";
import HomeMemberList from "@/components/HomeMemberList.vue";
import Contacts from "@/views/Contacts.vue";
import videoPoster from "@/assets/img/shipin3.png";
import { bannerinfo, getByNav, baseByNav,memberunitList } from '../api/api'
export default {
  name: "Home",
  components: {
    HomeItemTitle,
    HomeDirectorList,
    HomeMemberList,
    Contacts,
  },
  data() {
    return {
      summary:"",
      df:"1px",
      ggg:true,
      sdf:'',
      xinjia:'',
      sdfs:'',
      mi:'',
      nate:60,
      z:'116.331398',
      x:'39.897445',
      LocationCity: '正在定位',
            success: false,
      wei:0,
      weis:0,
      weiTop:0,
      weiTops:0,
      numLeng:0,
      gao:'',
      ce:"中文",
      url:'',
      chOrEn:sessionStorage.getItem('chOrEn'),
      banners: [],
      title:'',
      num:'',
      urlfirst:'',
      urlsecond:'',
      urlthird:'',
      content:'',
      navigationId:1,
      memberunitList:[],
      baseByNavtit:{},
      y_bj:{
        backgroundImage:''
      },
      mechanism:{},
      directors: [
        {
          id: 1,
          avatar: "",
          name: "格楚·艾希利曼",
          address: "瑞士圣•乌尔班雕塑公园",
        },
        {
          id: 2,
          avatar: "",
          name: "陈佩媛",
          address: "瑞士",
        },
        {
          id: 3,
          avatar: "",
          name: "李佳桐",
          address: "中国长春世界雕塑园",
        },
        {
          id: 4,
          avatar: "",
          name: "王明山",
          address: "中国长春世界雕塑园",
        },
        {
          id: 5,
          avatar: "",
          name: "单红梅",
          address: "瑞士圣•乌尔班雕塑公园",
        },
      ],
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "http://www.ispunion.org/baseinfo/mp4.mp4", //url地址
          },
        ],
        poster: videoPoster, //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
      members:[
        {
          id:1,
          img:require('../assets/img/member1.png'),
          en:'Boston Sculptors Gallery',
          zn:'波士顿雕塑家艺术馆',
          county:'美国'
        },
        {
          id:2,
          img:require('../assets/img/member2.png'),
          en:'Chianti Sculpture Park',
          zn:'意大利基安蒂雕塑公园',
          county:'意大利'
        },
        {
          id:3,
          img:require('../assets/img/member3.png'),
          en:'Sculpture For New Orleans',
          zn:'新奥尔良雕塑公园',
          county:'美国'
        },
        {
          id:4,
          img:require('../assets/img/member4.png'),
          en:'Grounds for Sculpture',
          zn:'雕塑庭园',
          county:'美国'
        }
      ],
      lats:[
        // {
        //   id:1,
        //   lat:8.1823,
        //   lng:47.32,
        //   title:"圣•乌尔班雕塑公园",
        //   img:"",
        //   // img:require('../assets/img/art-st-urban.jpg'),
        //   des:''
        // },
        // {
        //   id:2,
        //   lat:2.262258,
        //   lng:43.3118,
        //   title:"贝丁顿雕塑花园",
        //   img:"",
        //   // img:require('../assets/img/BeddingtonSculptureGarden.jpg'),
        //   des:''
        // },{
        //   id:3,
        //   lat:71.0349,
        //   lng:42.2129,
        //   title:"波士顿雕塑家艺术馆",
        //   img:"",
        //   // img:require('../assets/img/member1.png'),
        //   des:''
        // },
        // {
        //   id:4,
        //   lat:11.1950,
        //   lng:43.1907,
        //   title:"基安蒂雕塑公园",
        //   img:"",
        //   // img:require('../assets/img/ChiantiSculpturePark.jpg'),
        //   // img:require(''),
        //   des:''
        // },
        // {
        //   id:5,
        //   lat:-74.6744,
        //   lng:40.207,
        //   title:"雕塑庭园",
        //   img:"",
        //   // img:require('../assets/img/GroundsforSculpture.jpg'),
        //   // img:require(''),
        //   des:''
        // },
        // {
        //   id:6,
        //   lat:24.05,
        //   lng:56.53,
        //   title:"佩德维尔露天雕塑博物馆",
        //   img:"",
        //   // img:require('../assets/img/PedvaleOpen-AirArtMuseum.jpg'),
        //   des:''
        // },
        // {
        //   id:7,
        //   lat:-89.9272,
        //   lng:30.0675,
        //   title:"新奥尔良雕塑公园",
        //   img:"",
        //   // img:require('../assets/img/SculptureForNewOrleans.jpg'),
        //   // img:require(''),
        //   des:'新奥尔良雕塑公园将本土的，地区的和各国艺术家们的纪念性雕塑作品汇聚在一起举办室外展览，以此来改善新奥尔良市视觉艺术的重修与复原。通过国际艺术家如路易丝﹒布尔乔亚、马克﹒迪﹒苏维罗、亚历山大﹒考尔德的支持，以及他们对于纪念性雕塑作品和积极的视觉符号两个项目的贷款，助力新奥尔良的复苏。估算每年有一千万游客观赏一至多个摆放在城市各处的这类雕塑作品。'
        // },
        // {
        //   id:8,
        //   lat:73.5339,
        //   lng:38.55,
        //   title:"苏沃德·强生工作室",
        //   // img:require('../assets/img/woca.jpg'),
        //   img:"",
        //   des:''
        // },{
        //   id:9,
        //   lat:74.0215,
        //   lng:40.425167,
        //   img:"",
        //   // img:require('../assets/img/CaroleFeuermanSculptureFoundation.jpg'),
        //   title:"卡罗尔•富尔曼雕塑基金会",
        //   des:''
        // }
      ],
      mark:1,
    };
  },
  created(){
    // this.$nextTick(() => {
    //     // 禁用右键
    //     document.oncontextmenu = new Function("event.returnValue=false");
    //     // 禁用选择
    //     document.onselectstart = new Function("event.returnValue=false");
    //   });
    // this.getLocation();
    let getBynavid1 = {
      navigationId:10
    }
    baseByNav({...getBynavid1}).then(res=>{
      this.baseByNavtit = res.data.data
      let myPlayer = this.$refs.videoPlayer.player;
      myPlayer.src(res.data.data.videoUrl); //根据userType的不同展示不同的视频地址
      // this.playerOptions.sources.src = res.data.data.videoUrl
      // this.y_bj.backgroundImage = "url("+res.data.data.urlfirst+")"
    })
    getByNav({...getBynavid1}).then(res=>{
      this.y_bj.backgroundImage = "url("+res.data.data.url+")"
      // let myPlayer = this.$refs.videoPlayer.player;
      // myPlayer.src(res.data.data.videoUrl); //根据userType的不同展示不同的视频地址
      // // this.playerOptions.sources.src = res.data.data.videoUrl
      // this.baseByNavtit = res.data.data
      // this.y_bj.backgroundImage = "url("+res.data.data.urlfirst+")"
    })
    let getBynavid3 = {
      navigationId:12
    }
    baseByNav({...getBynavid3}).then(res=>{
      //console.log(res)
      this.mechanism = res.data.data
    })
    let navigationId = {
      navigationId:1,
      chOrEn:1
    }
    let getBynavid = {
      navigationId:11
    }
    //banner 
    bannerinfo({...navigationId}).then(res=>{
      this.banners = res.data.data
      // this.banners.push(res.data.data[0])
      // this.banners.push(res.data.data[1])
      // this.
      // console.log(this.banners)
    })
    //关于联盟
    baseByNav({...getBynavid}).then(res=>{
      this.summary = res.data.data.summary
      this.urlfirst = res.data.data.urlfirst
      this.urlthird = res.data.data.urlthird
      this.urlsecond = res.data.data.urlsecond
    })
    //成员单位
    let getBynavid2 = {
      navigationId:3,
      isShow:1
    }
    let self=this
    memberunitList({...getBynavid2}).then(res=>{
      //console.log(res)
      // 
      this.memberunitList = res.data.data;
        // 
      this.num=(this.memberunitList.length/3)*100+"%"
      // for(let t=0;t<res.data.data.length;t++){
        
      //   self.lats[t].img=res.data.data[t].url;
        
      // // this.initMap();
      // }
      self.lats=res.data.data;
      this.initMap();
      // this.memberunitList.push(res.data.data[0])
      // this.memberunitList.push(res.data.data[1])
      // this.memberunitList.push(res.data.data[2])
      // this.memberunitList.push(res.data.data[3])
    })
    let data = [
      18
      // navigationId:5,
      // title:'测',
      // content:'测试文章内容',
      // chOrEn:1
    ]
    
  },
  watch: {
      // gao: function(newVal, oldVal) {
      //     this.gao=this.$refs.piediv.getBoundingClientRect().top+"px";
      //     // 
      //     console.log(1,this.gao)
      //     console.log(2,this.this.$refs.piediv.getBoundingClientRect().top+"px")
      // }
  },
  mounted() {
    this.getLocation();
    this.initMap();
    this.init();
    this.gao=this.$refs.piediv.getBoundingClientRect().top+"px";
    // 
    this.wei=this.$refs.zhuanZi.getBoundingClientRect().left+this.$refs.zhuanZi.clientWidth-150
    this.weis=this.$refs.zhuanZi.getBoundingClientRect().left+this.$refs.zhuanZi.clientWidth-200
    this.weiTop=this.$refs.zhuanZi.offsetTop+this.$refs.zhuanZi.clientHeight/2
    // 
    this.weiTops=this.$refs.zhuanZi.offsetTop+this.$refs.zhuanZi.clientHeight-this.$refs.imgs.clientHeight
    // this.weiTop=this.$refs.zhuanZi.getBoundingClientRect().top
    this.mi=this.$refs.zhuanZi.clientHeight
    // this.$refs.de.clientHeight-this.$refs.videoPlayer.clientHeight
    this.nate=(-(this.$refs.de.clientHeight-this.$refs.videoPlayer.$refs.video.clientHeight)/2)
    if(this.nate>0){
      if(this.nate>30){
        this.nate=(this.nate-30)
      }else{
        this.nate=this.nate
      }
    }else{
      this.nate=-(this.nate-100)
    }
    // console.log("测试",this.nate)
    // alert(-this.nate)
    // alert(this.$refs.de.clientHeight)
    // alert(this.$refs.videoPlayer.$refs.video.clientHeight)
    // 
    
    // 
    // 
    this.timer=setInterval(this.handleScrollx, 1000);
    this.tt()
    window.addEventListener('scroll',this.handleScrollx,true)
    // 
  },
 
  methods:{
    getLocation() {
        // var geolocation = new BMap.Geolocation("all");
        var _this = this;
        _this.LocationCity = '正在定位';
        // geolocation.getCurrentPosition(function getinfo(position){
        //   var city = position.address.city;             //获取城市信息
        //     var province = position.address.province;    //获取省份信息
        //     // var city = position.latitude;             //获取城市信息
        //     // var province = position.longitude;    //获取省份信息
        //     map.centerAndZoom(new BMap.Point(position.latitude, position.longitude), 11);
        //     // 
        //     _this.LocationCity = city;
        //     _this.success = true;
        // }, function(e) {
        //     _this.LocationCity = '定位失败, 请点击重试';
        //     this.success = false;
        // }, {provider: 'baidu'});
        var map = new BMap.Map("all");    // 创建Map实例
        // var map = new BMap.Map("allmap");
        // var point = new BMap.Point(116.331398,39.897445);
        // map.centerAndZoom(point,12);
        
        // var geolocation = new BMap.Geolocation();
        // geolocation.getCurrentPosition(function(r){
        //   if(this.getStatus() == BMAP_STATUS_SUCCESS){
        //     var mk = new BMap.Marker(r.point);
        //     // var polyline = new BMap.Polyline(pts,{ strokeColor: "#FFFFFF",  });
        //     map.addOverlay(mk);
        //     // map.setMapStyleV2(polyline);
        //     // map.panTo(r.point);
        //     this.x=r.point.lng
        //     this.z=r.point.lat
        //     // alert('您的位置：'+r.point.lng+','+r.point.lat);
        //   }       
        // });
        // map.centerAndZoom(new BMap.Point(this.s, this.z), 15);  // 初始化地图,设置中心点坐标和地图级别
        map.centerAndZoom(new BMap.Point(125.340278, 43.828262), 15);  // 初始化地图,设置中心点坐标和地图级别
        //添加地图类型控件
        // map.addControl(new BMap.MapTypeControl({
        //   mapTypes:[
        //           BMAP_NORMAL_MAP,
        //           BMAP_HYBRID_MAP
        //       ]}));	  
        // map.setCurrentCity("北京");          // 设置地图显示的城市 此项是必须设置的
        map.enableScrollWheelZoom(true);
    },
    zuo(){
      if(this.numLeng!=0){
        this.numLeng--
        }else{
          this.numLeng=0
      }
      this.$refs.divIts.scrollLeft =(this.$refs.divIts.clientWidth/3)*this.numLeng
    },
    you(){
      if(this.numLeng<this.$refs.zhi.$el.children.length-3){
        this.numLeng++
      }else{
        
      }
      this.$refs.divIts.scrollLeft =(this.$refs.divIts.clientWidth/3)*this.numLeng
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    tt(){
      if (this._isMobile()) {
        // alert("手机端");
        // debugger
        // this.$router.replace('/m_index');
      } else {
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){      //判断是否是微信环境
          this.ggg=false
        }else{
              //非微信环境逻辑
        }
        // this.$router.replace('/pc_index');
      }
    },
    handleScrollx() {
      // 
      // debugger
      this.mark++
      // setInterval(this.autoPlay(), 2500)
      if(this.mark==14){
        clearInterval(this.timer);
      }
      
      

      this.mi=this.$refs.zhuanZi.clientHeight
      // turan
      // element
      this.xinjia=this.$refs.dsaf.offsetLeft-184+'px'
      this.sdf=this.$refs.zhengjain.offsetTop+this.$refs.zhengjains.offsetHeight-this.$refs.turan.offsetHeight+'px'
      // console.log("第一元素",this.$refs.zhengjain.offsetTop)
      // console.log("第一元素",this.$refs.zhengjain)
      // debugger
      // console.log("第二元素",this.$refs.zhengjains.offsetHeight)
      // console.log("第三元素",this.$refs.turan.offsetHeight)
      // console.log("第四元素",this.$refs.zhengjain.offsetTop+this.$refs.zhengjains.offsetHeight-this.$refs.turan.offsetHeight+'px')
      // console.log(2,this.$refs.zhengjain.offsetTop,this.$refs.zhengjains.offsetHeight,this.$refs.turan.offsetHeight,this.$refs.zhengjain.offsetTop+this.$refs.element.offsetHeight+this.$refs.zhengjain.offsetHeight-this.$refs.turan.offsetHeight-50-630+'px')
      this.sdfs=this.$refs.zhengjain.offsetTop+this.$refs.element.offsetHeight+this.$refs.zhengjain.offsetHeight-this.$refs.turan.offsetHeight-630+'px'// 
      
      
      this.weiTop=this.$refs.zhuanZi.offsetTop+this.$refs.zhuanZi.clientHeight/2
      this.weiTops=this.$refs.zhuanZi.offsetTop+this.$refs.zhuanZi.clientHeight-this.$refs.imgs.clientHeight
      // 
      // console.log('滚动高度',window.pageYOffset)
      // console.log('滚动高度',this.weiTop)
      // console.log('距离顶部高度',this.$refs.element.offsetHeight+this.$refs.elements.offsetHeight)
      // this.gao=this.$refs.element.offsetHeight+this.$refs.elements.offsetHeight+"px";
      // this.gao=this.$refs.element.offsetHeight+this.$refs.elements.offsetHeight+"px";
      // this.gao=this.$refs.element.offsetHeight+this.$refs.elements.offsetHeight-this.$refs.elementsd.offsetTop+"px";
      this.gao=this.$refs.piediv.offsetTop-this.$refs.gaos.offsetHeight+"px"
      

      // this.gao=this.$refs.piediv.getBoundingClientRect().top+"px";
    // 
      // this.wei=this.$refs.zhuanZi.getBoundingClientRect().left+this.$refs.zhuanZi.clientWidth-150
      this.wei=this.$refs.zhuanZi.offsetLeft+this.$refs.zhuanZi.clientWidth-178
      
      // this.weis=this.$refs.zhuanZi.getBoundingClientRect().left+this.$refs.zhuanZi.clientWidth-200
      this.weis=this.$refs.zhuanZi.offsetLeft+this.$refs.zhuanZi.clientWidth-200
      this.weiTop=this.$refs.zhuanZi.offsetTop+this.$refs.zhuanZi.clientHeight/2
      // 
      this.weiTops=this.$refs.zhuanZi.offsetTop+this.$refs.zhuanZi.clientHeight-this.$refs.imgs.clientHeight
      // this.weiTop=this.$refs.zhuanZi.getBoundingClientRect().top
      this.mi=this.$refs.zhuanZi.clientHeight
      // this.$refs.de.clientHeight-this.$refs.videoPlayer.clientHeight
      this.nate=(-(this.$refs.de.clientHeight-this.$refs.videoPlayer.$refs.video.clientHeight)/2)
      if(this.nate>0){
        // if(this.nate>30){
          //   this.nate=(this.nate-30)
        // }else{
          this.nate=this.nate
        // }
      }else{
        this.nate=-(this.nate)
      }
      // console.log("测试",this.nate)
      var userAgent = navigator.userAgent;
      if(userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1){
          // this.$refs.element.offsetHeight
          // this.$refs.element.offsetTop
          console.log(this.$refs.element.offsetHeight,this.$refs.element.offsetTop)
          this.sdf=(this.$refs.zhengjains.offsetTop-this.$refs.element.offsetTop-30-this.$refs.element.offsetHeight)+this.$refs.zhengjains.offsetHeight-this.$refs.turan.offsetHeight+'px'
      }
      
    },
    initMap(){
      // BmlHeatmap(this.ak).then((BMapGL) => {
        debugger
        var map = new BMap.Map("allmap");
        var mapStyle={  style : "midnight" }  
        map.setMapStyle(mapStyle);
        var point = new BMap.Point(-5.547388,46.063783);
        var opts = {
          width : 250,     // 信息窗口宽度
          height: 156,     // 信息窗口高度
          // title : "成员单位名称" , // 信息窗口标题
          enableMessage:true//设置允许信息窗发送短息
        };
        map.centerAndZoom(point, 1);
        debugger
        this.lats.map(item=>{
          
          var content=`<img src=${item.url} width='250px'  height='115px'/><br/>${item.titleCh}`;
          debugger
          var point = new BMap.Point(item.latitude, item.longitude);
          // this.addMarker(point,map);
          var marker = new BMap.Marker(point);
          map.addOverlay(marker);
          marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
          // 
          // this.addClickHandler(content,marker);

          marker.addEventListener("click",(e)=>{
            //this.openInfo(content,e)
              var p = e.target;
              // 
              var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
              var infoWindow = new BMap.InfoWindow(content,opts);  // 创建信息窗口对象 
              map.openInfoWindow(infoWindow,point); //开启信息窗口
            }
          );
        })
        // var myIcon = new BMap.Icon("https://i.loli.net/2020/10/21/hQeUEjzTaZv63uB.png", new BMap.Size(23, 35));
        // var marker=new BMap.Marker(e.point,{icon:myIcon});
      // })
      // .catch((err)=>{
      //   console.log(err)
      // })
    },
    init(){
      // BmlHeatmap(this.ak).then((BMapGL) => {
        var map = new BMap.Map("all");
        // var mapStyle={  style : "midnight" }  
        // map.setMapStyle(mapStyle);
        var point = new BMap.Point(125.340278, 43.828262);
        // map.centerAndZoom(new BMap.Point(125.340278, 43.828262), 15);
        var opts = {
          width : 250,     // 信息窗口宽度
          height: 250,     // 信息窗口高度
          // title : "成员单位名称" , // 信息窗口标题
          enableMessage:true//设置允许信息窗发送短息
        };
        map.centerAndZoom(point, 15);
        this.lats.map(item=>{
          // 
          
          // var content=`<img src=${item.img} /><br/>${item.title}`;
          // var point = new BMap.Point(125.340278, 43.828262);
          //this.addMarker(point,map);
          var marker = new BMap.Marker(point);
          map.addOverlay(marker);
          // marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
          // 
          //this.addClickHandler(content,marker);

          marker.addEventListener("click",(e)=>{
            //this.openInfo(content,e)
              var p = e.target;
              // 
              var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
              var infoWindow = new BMap.InfoWindow(content,opts);  // 创建信息窗口对象 
              map.openInfoWindow(infoWindow,point); //开启信息窗口
            }
          );
        })
      // })
      // .catch((err)=>{
      //   console.log(err)
      // })
    },
    addClickHandler(content,marker){
      marker.addEventListener("click",(e)=>{
        this.openInfo(content,e)}
      );
    },
    openInfo(content,e){
      var p = e.target;
      var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
      var infoWindow = new BMap.InfoWindow(content,opts);  // 创建信息窗口对象 
      map.openInfoWindow(infoWindow,point); //开启信息窗口
    },
    // 编写自定义函数,创建标注
	  addMarker(point,map){
      
    },
    goUnion(){
      this.$router.push('/union')
    },
    goProposal(){
      this.$router.push('/proposal')
    },
    goMemeber(){
      // this.$router.push('/company')
      this.$router.push({
        path: '/union',
        query:{list: "2"}
      })
    },
    tiao(){
      this.$router.push('/union')
    }
  }
};
</script>
<style >
#allmap.BMap_cpyCtrl {
            display: none;
        }
        .anchorBL {
            display: none;
        }
#div::-webkit-scrollbar {
  width: 0;
}
#divIt::-webkit-scrollbar {
 width: 7px;
 /* height: 10px; */
 height: 0px;
}
/* 滚动条的滑块 */
#divIt::-webkit-scrollbar-thumb {
 background-color: #2539B4;
 border-radius: 30px;
}
  p {
    text-align: justify;
    font-size: 18px;
    text-indent: 28px;
    margin-bottom: 20px;
  }
  .tuji .vjs_video_433-dimensions.vjs-fluid{
    padding-top: 33.25%;
  }
  .tuji .video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3 {
    /* max-width: 59%; */
    width: 583px;
    height:328px;
  }
</style>
<style lang="less" scoped>
.beijingtupian{
  background: url("../assets/img/ce.png")  no-repeat;
          // background-size: 100% 100%
          ;
  // background-position: 10% 1px;
    background-size: 368px 368px;
}
.zhuan{
  padding:0px;
  // padding-top:100px;
  height:10px;
  color:#24367D;
  // -moz-transform: rotate(90deg);
  // -webkit-transform: rotate(90deg);
  transform:rotate(90deg);
  
  font-size: 40px;
  font-weight: bold;
  // display: block;
  position: absolute;         
  // left: 572px;
  // filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3)
}
.zhuans{
  padding:0px;
  // padding-top:100px;
  // height:10px;
  color:#24367D;
  // -moz-transform: rotate(90deg);
  // -webkit-transform: rotate(90deg);
  transform:rotate(90deg);
  
  font-size: 40px;
  font-weight: bold;
  // display: block;
  position: absolute;         
  z-index:1
  // left: 572px;
  // filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3)
}
.left{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flexEnd{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.centers{
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.cent{
  display: flex;
  justify-content: center;
  align-items: center;
}
.flexStart{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.centersTop{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.check_mores{
  width: 284px;
  height: 50px;
  background: #FFFFFF;
  color: #24367D;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  // margin-right: 4px;
  // border-radius: 5px;
}
.ce{
  background: url("../assets/img/beijing.png") ;
  // width:100%;
  // height:100%;
  background-size: cover;
  background-position: center
}
.home {
  .reds{
      // overflow:auto;
      overflow-x: hidden; overflow-y: auto;
      // flex:1;
      height: 100%;
  }
  .banner {
    width: 100%;
    height: 420px;
    // margin-top: 110px;
    // z-index:99;
    img {
      width: 100%;
      // height: auto;
    }
    /deep/ .el-carousel__container {
      height: 100% !important;
    }
  }
  // .hr50{
  //   width: 100%;
  //   height: 100px;
  //   background: #fff;
  // }
  .union_info {
    width: 100%;
    // background: url("../assets/img/bei.png") no-repeat;
    background-size:100% 100%; 
    // padding: 100px 0;
    .union_info_container {
      .union_info_content {
        margin-top: 42px;
        .union_info_content_top {
          display: flex;
          margin-bottom: 70px;
          .top_left {
            flex: 1;
            overflow: hidden;
            cursor: pointer;
            img {
              width: 100%;
              transition: all 1s ease;
            }
            img:hover{
              transform: scale(1.2);
            }
          }
          .top_right {
            flex: 1;
            padding-left: 30px;
            .right_top {
              position: relative;
              margin-bottom: 20px;
              width: 100%;
              height: 60px;
              .top_block1 {
                width: 50px;
                height: 50px;
                background: #1954c9;
                position: absolute;
                right: 0;
                top: 0;
                z-index: 2;
              }
              .top_block2 {
                width: 50px;
                height: 50px;
                background: #5d87d9;
                position: absolute;
                right: 12px;
                top: 12px;
                z-index: 1;
              }
            }
            .right_center {
              margin-bottom: 50px;
              p {
                font-size: 18px;
                color: #575757;
                letter-spacing:2px;
                line-height: 26px;
                margin-bottom: 12px;
                text-align: justify;
                text-indent: 36px;
              }
            }
            .right_bottom {
              .bottom_line1 {
                width: 60px;
                height: 5px;
                background: #5d87d9;
                margin-bottom: 12px;
              }
              .bottom_line2 {
                width: 112px;
                height: 5px;
                background: #1954c9;
                margin-bottom: 12px;
                margin-left: 27px;
              }
            }
          }
        }
        .union_info_content_bottom {
          display: flex;
          .bottom_left {
            flex: 1;
            padding-right: 80px;
            .left_info{
              overflow: hidden;
              width: 337px;
              height: 461px;
              cursor: pointer;
              img{
                width: 100%;
                height: 100%;
                transition: all 1s ease;
              }
              img:hover{
                transform: scale(1.2);
              }
            }
            .check_more {
              display: flex;
              margin-top: 20px;
              cursor: pointer;
              .check_more_text {
                width: 110px;
                height: 50px;
                background: #1954c9;
                color: #fff;
                line-height: 50px;
                text-align: center;
                font-size: 18px;
                margin-right: 4px;
                border-radius: 5px;
              }
              .check_more_icon {
                width: 50px;
                height: 50px;
                background: #1954c9;
                border-radius: 5px;
                color: #fff;
                line-height: 50px;
                text-align: center;
                font-size: 18px;
              }
            }
          }
          .bottom_right {
            flex: 1;
            position: relative;
            overflow: hidden;
            .bottom_right_box {
              width: 100%;
              height: 400px;
              border: 2px solid #1954c9;
              transition: all 1s ease;
            }
            .bottom_right_img {
              position: absolute;
              left: 30px;
              top: 30px;
              width: 100%;
              transition: all 1s ease;
              cursor: pointer;
            }
            .bottom_right_img:hover{
              transform: scale(1.2);
            }
          }
        }
      }
    }
  }
  .union_initiatives {
    width: 100%;
    height:800px;
    // background: url("../assets/img/ce.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    .union_initiatives_mask {
      width: 100%;
      height: 100%;
      // background: rgba(0, 0, 0, 0.5);
      .container {
        height: 100%;
        padding:100px 0;
        color: #fff;
        display: flex;
        .initiatives_left {
          flex: 1;
          position: relative;
          padding-right: 30px;
          h1 {
            font-size: 28px;
            // line-height: 90px;
            margin-bottom:20px
          }
          p {
            font-size: 16px;
            color: #fefefe;
            line-height: 24px;
          }
          .check_more {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 128px;
            background: #FFFFFF;
            color: #24367D;
            font-size: 18px;
            text-align: center;
            line-height: 40px;
            height: 40px;
            border-radius: 5px;
            cursor: pointer;
          }
        }
        .initiatives_right {
          // flex: 1;
          width:40%;
          padding-left: 80px;
          #video {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .union_initiatives:hover{

  }
  .board_directors {
    width: 100%;
    height: 766px;
    background-image: url("../assets/img/board.png");
    background-repeat: no-repeat;
    background-position: 50px bottom;
    background-size: auto 70%;
    padding: 40px 0;
    .container {
      .board_directors_list {
        display: flex;
        margin-top: 90px;
      }
    }
  }
  .secretariat {
    width: 100%;
    color: #fff;
    padding: 49px 0;
    // background:url('../assets/img/mishu_bg.png') no-repeat;
    background-size: 100% 100%;
    .container {
      .item_title {
        /deep/ h1 {
          color: #fff !important;
        }
        /deep/ .title_hr_line {
          background: #fff;
        }
        /deep/ .dot_little {
          background: #fff;
        }
        /deep/ .dot_big {
          background: #fff;
        }
        /deep/ h5 {
          color: #fff;
        }
      }
      .secretariat_content{
        // width: 960px;
        // height: 450px;
        background: #ffffff;
        // padding:45px;
        border-radius: 8px;
        // margin:44px auto 0;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .content_left{
          // border:1px dashed  #333333;
          padding:3%;
          width: 472px;
          // width: 35%;
          // height: 655px;
          overflow: hidden;
          // margin-right: 20px;
          img{
            width: 100%;
            height: 100%;
            transition: all 1s ease;
          }
          img:hover{
            transform: scale(1.2);
          }
        }
        .content_right{
          // overflow:auto;
          overflow-x: hidden; overflow-y: auto;
          flex:1;
          height: 100%;
          h2{
            font-size: 20px;
            line-height: 34px;
            color: #2D2D2D;
            text-align: center;
          }
          p{
            font-size: 18px;
            line-height: 28px;
            color: #4B4B4B;
            margin:30px 0 ;
          }
          a{
            color: #1954c9;
          }
        }
      }
    }
  }
  .member{
    min-width:1440px;
    // width:100%;
    // padding:100px 0 ;
    // background:#FAFAFC;
    background-image: url("../assets/img/mapstree.png");
    // background-size: 100% 100%;
    // width:100%;
    // background-repeat: no-repeat;
    // background-position: 50px bottom;
    // background-size: auto 70%;
    // position: relative;
    #allmap{
        // width: 1200px;
        height: 300px;
        margin-top: 50px;
        // position: absolute;
        // left:50%;
        // margin-left: -600px;
        // top:90px;
        // z-index: -1;
    }
    #all{
        // width: 1200px;
        height: 280px;
        margin-top: 50px;
        // position: absolute;
        // left:50%;
        // margin-left: -600px;
        // top:90px;
        // z-index: -1;
    }
    .container{
      .check_more {
            
            width: 128px;
            background: #1954c9;
            color: #fff;
            font-size: 18px;
            text-align: center;
            line-height: 40px;
            height: 40px;
            border-radius: 5px;
            margin:30px auto;
            cursor: pointer;
          }
      
    }
  }
}
</style>